import { render, staticRenderFns } from "./QuizSummary.vue?vue&type=template&id=5c248cac&scoped=true&"
import script from "./QuizSummary.vue?vue&type=script&lang=js&"
export * from "./QuizSummary.vue?vue&type=script&lang=js&"
import style0 from "./QuizSummary.vue?vue&type=style&index=0&id=5c248cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c248cac",
  null
  
)

export default component.exports